import React from 'react';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';

import { Article } from '@/modules/articles/model/article';
import { useWidgetNavigate } from '@/core/widgets/export';
import ArticleBodyDisplay from '@/modules/articles/components/articles/article-body-display';
import { DateFormat } from '@/core/date/export';
import '@/modules/articles/components/pins/pinned-article.css';
import embedLocationInXhtml from '@/modules/articles/util/embedLocationInXhtml';

export default function PinnedArticle({
  article,
  className = 'note-yellow',
  newVersionAvailable,
  widgetLink,
}: {
  article: Article;
  className?: string;
  newVersionAvailable?: boolean;
  widgetLink?: React.ReactNode;
}) {
  const navigate = useWidgetNavigate();
  const xhtml = embedLocationInXhtml(article);

  return (
    <div
      className={
        'h-100 text-black p-1  h-100 overflow-auto d-flex flex-column container-element ' +
        className
      }
      style={{}}
    >
      <div className={'mb-2'}>
        <div className={'flex-grow-1'}>
          <h3>{article.headline}</h3>
        </div>

        <div className={'d-flex justify-content-between'}>
          <div className={'small '}>
            <div>
              <DateFormat format={'MMM D, h:mm a'} date={article.firstcreated} />,{' '}
              <strong>{dayjs(article.firstcreated).fromNow()}</strong>
            </div>
          </div>
          {article.byline && (
            <div className={' fst-italic  small text-end'}>By {article.byline}</div>
          )}
        </div>
      </div>

      <div className={'h-100 overflow-auto container-responsive-text '}>
        <ArticleBodyDisplay article={article} xhtml={xhtml} pinnedWidget />
      </div>

      {newVersionAvailable && (
        <div className={'position-absolute bottom-0 end-0 p-2'}>
          <button className={'btn btn-sm btn-primary'} onClick={event => navigate('/')}>
            <FontAwesomeIcon icon={faRotateRight} /> New Version Available
          </button>
        </div>
      )}
      {widgetLink}
    </div>
  );
}
